export default __webpack_public_path__ + "static/media/Chan04.6d95c427.png";